import loadable from '@loadable/component';

// 懒加载组件
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const HospitalInventoryQuery = loadable(() => import('./hospitalInventoryQuery/HospitalInventoryQuery'));

export const subRoutes = [
  { // M832258001 销售结算确认管理
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  { // M832258001 销售结算确认管理-单据明细页
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  { // M832251015 (丰都人民)医院库存查询
    path: '/HospitalInventoryQuery',
    component: HospitalInventoryQuery
  }
];
